import React from "react";
import "./ActionBar.css";

/**
 * ActionBar — sticky bottom navigation bar
 *
 * Props:
 *   onBack       — handler for Back button
 *   onNext       — handler for Continue / Submit
 *   backLabel    — text for back button (default: "Back")
 *   nextLabel    — text for next button (default: "Continue →")
 *   backDisabled — disable back button
 *   nextDisabled — disable next button
 *   hideBack     — hide the back button (first step)
 *   nextLoading  — show spinner inside next button (API in progress)
 */
const ActionBar = ({
  onBack,
  onNext,
  backLabel = "← Back",
  nextLabel = "Continue →",
  backDisabled = false,
  nextDisabled = false,
  hideBack = false,
  nextLoading = false,
}) => {
  return (
    <>
      {/* Full-screen loading overlay — blocks all interaction while saving */}
      {nextLoading && (
        <div className="ab-overlay">
          <div className="ab-overlay__spinner" aria-label="Loading" role="status" />
        </div>
      )}
      <div className="action-bar">
        <div className="action-bar__inner">
          {!hideBack && (
            <button
              type="button"
              className="ab-btn ab-btn--ghost"
              onClick={onBack}
              disabled={backDisabled || nextLoading}
            >
              {backLabel}
            </button>
          )}
          <button
            type="button"
            className="ab-btn ab-btn--primary"
            onClick={onNext}
            disabled={nextDisabled || nextLoading}
          >
            {nextLabel}
          </button>
        </div>
      </div>
    </>
  );
};

export default ActionBar;
